import { Directive, InjectionToken, Inject, Optional,
  Host, ComponentRef, ElementRef, ViewContainerRef, Input, ComponentFactoryResolver, OnInit, OnDestroy } from '@angular/core';
import { NgControl } from '@angular/forms';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { merge, Observable, EMPTY } from 'rxjs';
import { FormSubmitDirective } from './form-submit.directive';
import { ControlErrorContainerDirective } from './control-error-container.directive';
import { ControlErrorComponent } from '../modals/control-error/control-error.component';


export const defaultErrors = {
    required: () => `Dato obbligatorio`,
    minlength: ({ requiredLength, actualLength }) => `Lunghezza minima richiesta ${requiredLength}, ${actualLength}`,
    pattern:  () => `Formato non valido`,
    email:  () => `Formato non valido`,
    ngbDate:  () => `Formato non valido`,
}

export const FORM_ERRORS = new InjectionToken('FORM_ERRORS', {
  providedIn: 'root',
  factory: () => defaultErrors
});

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '.form-control, .custom-control-input'
})
export class ControlErrorsDirective implements OnInit, OnDestroy {
  ref: ComponentRef<ControlErrorComponent>;
  container: ViewContainerRef;
  submit$: Observable<Event>;
  expressionResult: boolean;

  @Input() customErrors = {};

  constructor(private vcr: ViewContainerRef,
              private resolver: ComponentFactoryResolver,
              @Optional() controlErrorContainer: ControlErrorContainerDirective,
              @Inject(FORM_ERRORS) private errors,
              @Optional() @Host() private form: FormSubmitDirective,
              private controlDir: NgControl, private element: ElementRef) {
    this.container = controlErrorContainer ? controlErrorContainer.vcr : vcr;
    this.submit$ = this.form ? this.form.submit$ : EMPTY;
  }

  ngOnInit() {
    merge(
      this.submit$,
      this.control.valueChanges
    ).pipe(
      untilDestroyed(this)).subscribe(() => {
        const fg = this.element.nativeElement.closest('.form-group');
        if (fg) {
          fg.classList.remove('ng-invalid', 'ng-valid',
                    'ng-pristine', 'ng-touched',
                    'ng-dirty', 'ng-untouched');
          if (this.control.invalid) {
            fg.classList.add('ng-invalid');
          } else {
            fg.classList.add('ng-valid');
          }
          if (this.control.dirty) {
            fg.classList.add('ng-dirty');
          } else {
            fg.classList.add('ng-pristine');
          }
          if (this.control.touched) {
            fg.classList.add('ng-touched');
          } else {
            fg.classList.add('ng-untouched');
          }
        }

        const controlErrors = this.control.errors;

        if (controlErrors) {
          const errorsArray = [];
          Object.keys(controlErrors).forEach( k => {
            const getError = this.errors[k];
            if (getError) {
              errorsArray.push({
                text: getError(controlErrors[k]),
                code: k,
              });
            }
          });
          this.setError(errorsArray);
        } else if (this.ref) {
          this.setError(null);
        }
      });
  }

  get control() {
    return this.controlDir.control;
  }

  setError(errors: string[]) {
    if (!this.ref) {
      const factory = this.resolver.resolveComponentFactory(ControlErrorComponent);
      this.ref = this.container.createComponent(factory);
    }

    this.ref.instance.errors = errors;
  }

  ngOnDestroy() {
    // do nothing
  }
}
